export class HttpError extends Error {
    public statusCode: number | string = 200

    constructor(message: string, statusCode: number | string) {
        super(message)

        this.name = this.constructor.name

        this.statusCode = statusCode
    }
}

export const isHttpError = (error: Error): error is HttpError => (error as HttpError).statusCode !== undefined
